export default {
  actionIcon: 'StarIcon',
  highlightColor: 'warning',
  data: [
    {index: 0, label: 'Home', url: '/', labelIcon: 'HomeIcon', highlightAction: false},
    {index: 1, label: 'Consultas pendentes', url: '/pending-schedule', labelIcon: 'ClockIcon', highlightAction: false},
    {index: 2, label: 'Consultas agendadas', url: '/appointment', labelIcon: 'CalendarIcon', highlightAction: false},
    {index: 3, label: 'Prontuários - Consultas realizadas', url: '/medical-records', labelIcon: 'FolderPlusIcon', highlightAction: false},
    {index: 4, label: 'Prontuários - Pendências', url: '/pendency-medical-records', labelIcon: 'AlertTriangleIcon', highlightAction: false},
    {index: 5, label: 'Pacientes', url: '/my-patients', labelIcon: 'UsersIcon', highlightAction: false},
    {index: 6, label: 'Extrato', url: '/financial-extract', labelIcon: 'PercentIcon', highlightAction: false},
    {index: 7, label: 'Saldo e dados financeiros', url: '/balance-and-financial-data', labelIcon: 'dollar-sign', highlightAction: false},
  ]
}
